/** Visitações a outras lojas: a foto do certificado, a leitura por IA e o registro. */

import { api } from './client';
import type { FotoDoCertificado, ListaDeVisitas, Visita, VisitaEntrada, VisitanteRecebido } from '../types';

export interface FiltrosDeVisitas {
  membro_id?: number;
  ano?: number;
  busca?: string;
}

const semVazios = (filtros: FiltrosDeVisitas) =>
  Object.fromEntries(Object.entries(filtros).filter(([, v]) => v !== undefined && v !== ''));

export const ApiVisitas = {
  listar: async (filtros: FiltrosDeVisitas = {}) =>
    (await api.get<ListaDeVisitas>('/visitas', { params: semVazios(filtros) })).data,

  /** Guarda a foto e, com `ler`, devolve o que a IA leu — a visita só nasce no `criar`. */
  enviarFoto: async (arquivo: File, ler = true, aoProgredir?: (fracao: number) => void) => {
    const corpo = new FormData();
    corpo.append('arquivo', arquivo);
    corpo.append('ler', ler ? 'true' : 'false');
    return (
      await api.post<FotoDoCertificado>('/visitas/foto', corpo, {
        timeout: 300_000,
        onUploadProgress: (e) => {
          if (aoProgredir && e.total) aoProgredir(Math.min(1, e.loaded / e.total));
        },
      })
    ).data;
  },
  criar: async (dados: VisitaEntrada) => (await api.post<Visita>('/visitas', dados)).data,
  editar: async (id: number, dados: Partial<VisitaEntrada>) => (await api.patch<Visita>(`/visitas/${id}`, dados)).data,
  excluir: async (id: number): Promise<void> => {
    await api.delete(`/visitas/${id}`);
  },
  /** Irmãos de outras lojas que assinaram a folha de visitantes das nossas sessões. */
  recebidas: async (ano?: number) =>
    (await api.get<VisitanteRecebido[]>('/visitas/recebidas', { params: ano ? { ano } : {} })).data,
};

export const endpointDaFotoDaVisita = (id: number) => `/visitas/${id}/foto`;
